module.exports = __webpack_public_path__ + "static/media/Logo.51a7bf05.svg";